import { render, staticRenderFns } from "./FinalBatchLoad.vue?vue&type=template&id=3fbd8ec7&scoped=true&"
import script from "./FinalBatchLoad.vue?vue&type=script&lang=js&"
export * from "./FinalBatchLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd8ec7",
  null
  
)

export default component.exports